export const speedDialActionKey = {
    CUSTOMERSUPPORT: 'customersupport',
    DEPOSITISSUE: 'depositissue',
    WITHDRAWISSUE: 'withdrawissue',
    HOWTOPAY: 'howtopay',
}